import withSharedStyles from "../theme/Shared.style";

// Spacing comes from the parent GChipRow's gap.
const withCustomStyles = withSharedStyles(() => ({
  chip: {}
}));

export default withCustomStyles;
